<!-- src/App.vue -->
<template>
  <Analytics />
  <SpeedInsights />
  <div id="app" class="futuristic-container">
    <NavBar />
    <router-view />
    <footer class="app-footer">
      © {{ currentYear }} BullVerge. {{ $t('footer.rights') }}
    </footer>
        <BackToTopButton />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import { Analytics } from '@vercel/analytics/vue'
import { SpeedInsights } from "@vercel/speed-insights/vue"
import BackToTopButton from './components/BackTopButton.vue'
import { useCanonical } from './plugins/canonical'

export default {
  name: 'App',
  components: { NavBar, Analytics, SpeedInsights, BackToTopButton },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  setup () {
    useCanonical()
  }
}
</script>
<style>

.no-scroll {
  overflow: hidden;
}
</style>
